import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import { DetailedSikdaeForm, detailSikdaeExcelJson, DetailSikdaeSelectForm } from 'components/DetailedSikdae';
import DetailSikdaeResultV2 from 'components/DetailedSikdae/DetailSikdaeResultV2';
import * as cmAction from 'actions/commons';
import * as usgAction from 'actions/usage';
import cm from 'helpers/commons';
import storage from 'helpers/storage';
import toastr from 'helpers/toastr';
import * as usageService from 'services/usage';
// eslint-disable-next-line import/no-unresolved
import { Button, Modal } from 'semantic-ui-react';
import * as common from '../actions/commons';
import { LoadingBar } from '../components/Commons';
import { isDetailedSikdaeProAllowedCompany } from './DetailedSikdaeV2Access';

moment.tz.setDefault('Asia/Seoul');

const STATEMENT_STATUS_POLL_INTERVAL_MS = 1000;
const STATEMENT_STATUS_MAX_RETRY_COUNT = 120;

class DetailedSikdae extends Component {
  isUnmounted = false;

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pagerow: 15,
      user: [],
      store: [],
      group: null,
      policy: null,
      sgl_use: true,
      mul_use: true,
      sgl_cancel: true,
      mul_cancel: true,
      startTime: moment().hour(0),
      endTime: moment().hour(0),
      clickEvent: true,
      modal: false,
      loading: false,
      detailList: null,
      detailRows: [],
      statementId: null,
      isStatementRunning: false,
      partitionCount: 0,
      currentPartition: 0,
      totalRow: 0,
      isFetchingMore: false,
      isStatementCancelled: false,
      //
      excelPage: 1,
      excelData: [],
      isOpen: false,
      //
      CancelToken: axios.CancelToken,
      onCancel: null
      // cancelToken: axios.CancelToken.source(),
      // controller: new AbortController()
    };
  }

  async componentWillMount() {
    const company = storage.get('company') || {};
    const companyId = company ? company.id : null;

    if (!isDetailedSikdaeProAllowedCompany(companyId)) {
      this.props.history.push('/service/landing');
      return;
    }

    cm.propsInit(this.props);
    // 그룹 조회
    await this.divisionListSel();
    this.policyList(-1, null);
    this.groupList();
    const { download, commonsFn } = this.props;
    if (!download) {
      await commonsFn.reduxDataSet({
        type: 'download',
        name: 'isExcelDownload',
        value: false
      });
    }
  }

  componentDidMount() {
    cm.mainTitle('식대 상세조회(PRO)');

    const { registerExcelHandler } = this.props;
    if (registerExcelHandler) {
      registerExcelHandler(this.handleExcelModalOpen);
    }
  }

  componentWillUnmount() {
    this.isUnmounted = true;
    this.cancelRunningStatement();
    const { registerExcelHandler } = this.props;
    if (registerExcelHandler) {
      registerExcelHandler(null);
    }
    const { divisionSel } = this.props;
    divisionSel();
  }

  getStatementIdFromResponse = (response) => {
    const { data } = response || {};

    return data?.statementId || data?.id || data?.statement?.statementId || data?.result?.statementId || null;
  };

  getStatementStatusValue = (response) => {
    const { data } = response || {};

    return data?.status || data?.statementStatus || data?.statement?.status || data?.result?.status || null;
  };

  getStatementStatusMeta = (response) => {
    const { data } = response || {};
    const statusData = data?.statementStatus || data?.data || data || {};
    const rawDone = statusData?.done;

    return {
      done: rawDone === true || rawDone === 'true',
      totalRow: statusData?.totalRow || 0,
      partitionCount: statusData?.partitionCount || 0,
      status: statusData?.status,
      title: statusData?.title,
      message: statusData?.message
    };
  };

  getStatementMessage = (response) => {
    const { data } = response || {};

    return data?.message || data?.errorMessage || data?.statement?.message || null;
  };

  sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  cancelRunningStatement = async () => {
    const { statementId, isStatementRunning } = this.state;

    if (!statementId || !isStatementRunning) {
      return;
    }

    try {
      await usageService.CancelSikdaeDtlStatement(statementId);
    } catch (e) {
      console.log('###### cancel statement error : ', e);
    } finally {
      if (!this.isUnmounted) {
        this.setState({ isStatementRunning: false });
      }
    }
  };

  canLoadMorePartitions = () => {
    const { isStatementCancelled, currentPartition, partitionCount } = this.state;

    return !isStatementCancelled && partitionCount > 0 && currentPartition < partitionCount;
  };

  timeChange = async (type, value) => {
    const { cmAPI } = this.props;
    await cmAPI.changeTime({
      type: 'hour',
      name: type,
      value: value.format('HH')
    });

    const { hour } = this.props;
    this.setState({
      startTime: moment().hour(parseInt(hour.sTime, 10)),
      endTime: moment().hour(parseInt(hour.eTime, 10))
    });
  };

  initialize = async (e) => {
    if (e) e.stopPropagation();
    const now = moment().hour(0);
    const groups = [];
    const { policyIdxs } = this.props;
    // eslint-disable-next-line no-undef
    $('.master').each(function() {
      groups.push(parseInt(this.id, 10));
    });
    await this.setState({
      user: [],
      store: [],
      group: groups,
      policy: policyIdxs ? JSON.parse(JSON.stringify(policyIdxs)) : null,
      startTime: now,
      endTime: now,
      sgl_use: true,
      mul_use: true,
      sgl_cancel: true,
      mul_cancel: true
    });

    // 그룹체크박스 초기화
    // eslint-disable-next-line no-undef
    const $box = $('.checkbox.pure');
    $box.find('.master').prop('checked', true);
    $box.find('.child').prop('checked', true);
  };

  divisionListSel = async () => {
    const { cmAPI, date } = this.props;

    try {
      const params = {
        startdate: date
          ? moment(date.sDate).format('LL')
          : moment()
              .startOf('month')
              .format('LL'),
        enddate: date ? moment(date.eDate).format('LL') : moment().format('LL')
      };

      await cmAPI.divisionSel(params);

      const { divisionList } = this.props;

      if (divisionList && divisionList.data) {
        const { division, depth } = divisionList.data;
        const navi = cm.divisionNavigation(division);

        cm.staffDivisionNavigation(depth, navi);
      }
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### division call error : ', e);
    }
  };

  getParams = (type) => {
    const {
      page,
      pagerow,
      user,
      store,
      sgl_use: sglUse,
      mul_use: mulUse,
      sgl_cancel: sglCancel,
      mul_cancel: mulCancel,
      group,
      policy
    } = this.state;
    const { date, depth, hour, text } = this.props;

    const userArr = user.map((val) => {
      return val.id;
    });
    const storeArr = store.map((val) => {
      return val.id;
    });
    return {
      date: {
        startdate: date
          ? new Date(date.sDate).getTime()
          : new Date(
              moment()
                .startOf('month')
                .format('LL')
            ).getTime(),
        enddate: date ? new Date(date.eDate).getTime() : new Date(moment().format('LL')).getTime(),
        starttime: hour && hour.sTime !== hour.eTime ? new Date(moment(hour.sTime, ['h A'])).getTime() : null,
        endtime: hour && hour.sTime !== hour.eTime ? new Date(moment(hour.eTime, ['h A'])).getTime() : null
      },
      id: {
        // 배열들
        orgCode: depth ? depth.value : null,
        group: type === 'initialize' ? null : group,
        policy: type === 'initialize' ? null : policy,
        user: user && user.length > 0 ? userArr : null,
        store: store && store.length > 0 ? storeArr : null
      },
      code: {
        sgl_use: sglUse,
        mul_use: mulUse,
        sgl_cancel: sglCancel,
        mul_cancel: mulCancel
      },
      keyword: text ? text.value : null,
      page,
      pagerow,
      type: type === 'initialize' ? 'ALL' : null
    };
  };

  // 식대 상세내역 조회
  detailedSikdaeList = async (type) => {
    const statementParams = this.getParams(type);

    this.setState({
      loading: true,
      detailList: null,
      detailRows: [],
      statementId: null,
      isStatementRunning: false,
      partitionCount: 0,
      currentPartition: 0,
      totalRow: 0,
      isFetchingMore: false,
      isStatementCancelled: false
    });

    const com = storage.get('company') || {};
    const excelParams = {
      ...statementParams,
      comid: com.id,
      requestid: com.user && com.user.id,
      filetype: 'excel'
    };

    const { cmAPI } = this.props;
    cmAPI.changeExcel({ excel: excelParams });

    try {
      await this.cancelRunningStatement();

      const statementResponse = await usageService.CreateSikdaeDtlStatement(statementParams);
      const statementId = this.getStatementIdFromResponse(statementResponse);

      if (!statementId) {
        throw new Error('statementId not found');
      }

      if (!this.isUnmounted) {
        this.setState({ statementId, isStatementRunning: true });
      }

      const statusResponse = await this.waitForStatement(statementId);
      const { partitionCount, totalRow } = this.getStatementStatusMeta(statusResponse);

      if (!this.isUnmounted) {
        this.setState({
          partitionCount,
          totalRow
        });
      }

      await this.fetchStatementResult(statementId, 1);
    } catch (e) {
      const message =
        this.getStatementMessage(e) ||
        this.getStatementMessage(e.response) ||
        (e.response && e.response.data && e.response.data.message) ||
        e.message ||
        '데이터를 조회하는 동안 문제가 발생하였습니다.';

      toastr('top-right', 'error', message);
      console.log('###### detail statement error : ', e);
    } finally {
      if (!this.isUnmounted) {
        this.setState({ loading: false });
      }
    }
  };

  waitForStatement = async (statementId) => {
    let retryCount = 0;

    while (retryCount < STATEMENT_STATUS_MAX_RETRY_COUNT) {
      if (this.isUnmounted || this.state.statementId !== statementId) {
        return null;
      }

      const response = await usageService.SikdaeDtlStatementStatus(statementId);
      const { done, status, title, message } = this.getStatementStatusMeta(response);

      if (status === 0 || title || message) {
        throw new Error(message || title || 'statement 실행에 실패했습니다.');
      }

      if (done) {
        return response;
      }

      retryCount += 1;
      await this.sleep(STATEMENT_STATUS_POLL_INTERVAL_MS);
    }

    throw new Error('statement 상태 조회가 제한 시간 내에 완료되지 않았습니다.');
  };

  fetchStatementResult = async (statementId, partition = 1) => {
    const isInitialPartition = partition === 1;

    if (!this.isUnmounted) {
      this.setState({ isFetchingMore: !isInitialPartition });
    }

    const response = await usageService.SikdaeDtlStatementResult(statementId, { partition });

    const rows = Array.isArray(response?.data) ? response.data : [];

    if (!this.isUnmounted && this.state.statementId === statementId) {
      this.setState((prevState) => {
        const nextRows = partition === 1 ? rows : prevState.detailRows.concat(rows);
        const nextCurrentPartition = partition;
        const nextHasMore = !prevState.isStatementCancelled && nextCurrentPartition < prevState.partitionCount;

        return {
          detailList: response,
          detailRows: nextRows,
          currentPartition: nextCurrentPartition,
          isFetchingMore: false,
          isStatementRunning: nextHasMore
        };
      });
    }

    return response;
  };

  loadMorePartitions = async () => {
    const { statementId, isFetchingMore, loading } = this.state;

    if (!statementId || loading || isFetchingMore || !this.canLoadMorePartitions()) {
      return;
    }

    try {
      await this.fetchStatementResult(statementId, this.state.currentPartition + 1);
    } catch (e) {
      const message =
        this.getStatementMessage(e) ||
        this.getStatementMessage(e.response) ||
        (e.response && e.response.data && e.response.data.message) ||
        e.message ||
        '추가 데이터를 불러오는 동안 문제가 발생하였습니다.';

      toastr('top-right', 'error', message);

      if (!this.isUnmounted) {
        this.setState({ isFetchingMore: false, isStatementRunning: false });
      }
    }
  };

  detailedSikdaeExcelList = async (params) => {
    const { usageAPI, commonsFn } = this.props;
    const { excelPage, excelData, CancelToken } = this.state;

    const com = storage.get('company') || {};
    const comid = com.id;
    const requestid = com.user && com.user.id;

    const size = 5000;
    const config = {
      cancelToken: new CancelToken((onCancel) => {
        this.setState({ onCancel });
      })
    };
    await usageAPI.sikdaeDtlExcelList({ ...params, comid, requestid, page: excelPage, size }, config).catch(() => {
      alert('데이터를 불러 오는동안 문제가 발생하였습니다. 잠시후 다시 시도해주세요.');
      commonsFn.reduxDataSet({
        type: 'download',
        name: 'isExcelDownload',
        value: false
      });
    });

    const { detailExcelList } = this.props;
    if (detailExcelList.data && detailExcelList.data.length >= size) {
      this.setState({ excelPage: excelPage + 1, excelData: excelData.concat(detailExcelList.data) });
      await this.detailedSikdaeExcelList(params);
    } else if (detailExcelList.data) {
      this.setState({ excelData: excelData.concat(detailExcelList.data) });
    }
  };

  // 식대 그룹 조회
  groupList = async (type) => {
    const { cmAPI } = this.props;
    await cmAPI.sikGroupList();
    const { sikGroup } = this.props;
    const groupTemp = [];

    if (sikGroup && sikGroup.data) {
      const { group } = sikGroup.data;
      if (group && group.length > 0) {
        group.map(async (item) => {
          groupTemp.push(item.idx);
          await this.policyList(item.idx, type);
        });
      }
    }
    this.setState({ group: groupTemp });
  };

  // 식대그룹 별 정책 조회
  policyList = async (groupIdx) => {
    const { cmAPI } = this.props;
    await cmAPI.sikPolicyList(groupIdx);
    const { policyIdxs } = this.props;
    if (!policyIdxs || this.isUnmounted) return;
    this.setState({
      policy: JSON.parse(JSON.stringify(policyIdxs))
    });
  };

  // 상세검색 가맹점,사용자 추가
  addChoiceEvent = (obj, type) => {
    const { [type]: inputType } = this.state;
    const map = cm.excludeUseMap(inputType);
    if (map.get(obj.id)) {
      return;
    }
    inputType.push(obj);
    this.setState({
      [type]: inputType
    });
  };

  // 상세검색 가맹점,사용자 추가된 것 삭제
  delChoiceEvent = (id, type) => {
    const { [type]: inputType } = this.state;
    const delArr = inputType.filter((val) => {
      return val.id !== id;
    });
    this.setState({ [type]: delArr });
  };

  // 그룹 체크박스 선택
  groupSel = async (e) => {
    e.preventDefault();
    const { policyIdxs } = this.props;
    const { group, policy } = this.state;
    // eslint-disable-next-line no-undef
    const $target = $(e.target);
    const targetID = parseInt($target.attr('id'), 10);
    // eslint-disable-next-line no-undef
    const $targetGroup = $(`.g_${targetID}`);
    const policyIDs = $targetGroup
      .find('.child')
      .map(function() {
        return parseInt(this.id, 10);
      })
      .get();

    const policys = policy || (policyIdxs ? JSON.parse(JSON.stringify(policyIdxs)) : []);

    setTimeout(function() {
      if ($target.is(':checked')) {
        $targetGroup.find('input:checkbox').prop('checked', false);

        if (group.indexOf(targetID) > -1) {
          // 그룹 id
          group.splice(group.indexOf(targetID), 1);
          // 정책 id
          for (let i = 0; i < policys.length; i += 1) {
            for (let j = 0; j < policyIDs.length; j += 1) {
              if (policys[i] === policyIDs[j]) {
                policys.splice(policys.indexOf(policyIDs[j]), 1);
              }
            }
          }
        }
      } else {
        $targetGroup.find('input:checkbox').prop('checked', true);

        if (group.indexOf(targetID) === -1) {
          // 그룹 id
          group.push(targetID);
          // 정책 id
          // eslint-disable-next-line no-undef
          $.each(policyIDs, (key, value) => {
            // eslint-disable-next-line no-undef
            if ($.inArray(value, policys) === -1) {
              policys.push(value);
            }
          });
          // $.merge(policys, policyIDs);
        }
      }
    }, 100);
    await this.setState({
      clickEvent: false,
      policy: policys
    });
  };

  // 정책 체크박스 선택
  policySel = (e) => {
    e.preventDefault();
    const { group, policy } = this.state;
    // eslint-disable-next-line no-undef
    const $target = $(e.target);
    const targetID = parseInt($target.attr('id'), 10);
    const targerClassArr = $(`#${targetID}`)
      .parents('.group')
      .attr('class')
      .split(' ');
    const groupClassName = targerClassArr[targerClassArr.length - 1];
    const groupIdx = Number(groupClassName.split('g_')[1]);
    const policyCheckedLen = $(`.${groupClassName}`).find('input:checkbox[name=policy]:checked').length;

    setTimeout(function() {
      if ($target.is(':checked')) {
        $target.prop('checked', false);
        // policy 체크박스 안 되어 있을 시 group 체크박스 해제
        if (policyCheckedLen === 0) {
          $(`.${groupClassName}`)
            .find('input:checkbox')
            .prop('checked', false);

          group.splice(group.indexOf(groupIdx), 1);
        }
        // 정책 id
        policy.splice(policy.indexOf(targetID), 1);
      } else {
        $target.prop('checked', true);
        // policy 체크박스 1개 이상 체크 시 group 체크박스 체크
        if (policyCheckedLen === 1) {
          $(`.${groupClassName}`)
            .find('input:checkbox')
            .prop('checked', true);

          const policyArr = $(`.${groupClassName}`).find('input:checkbox[name=policy]');
          policyArr.each(function(idx) {
            const idNum = Number($(policyArr[idx]).attr('id'));
            if (targetID !== idNum) {
              $(`#${idNum}`).prop('checked', false);
            }
          });

          const groupAlreadyIn = group.some((el) => el === groupIdx);
          if (!groupAlreadyIn) {
            group.push(groupIdx);
          }
        }
        // 정책 id
        if (policy.indexOf(targetID) === -1) {
          policy.push(targetID);
        }
      }
    }, 100);

    this.setState({
      clickEvent: false,
      policy
    });
  };

  // 결제방식
  paymentOption = (e) => {
    const { name } = e.target;
    const { [name]: stateName } = this.state;
    this.setState({ [name]: !stateName });
  };

  // 확인
  submitForm = async (e) => {
    if (e) {
      e.preventDefault();
    }

    const { dateCheck, date } = this.props;
    const diff = moment(date.eDate).diff(date.sDate, 'day');
    if (diff > 92) {
      alert('조회 기간은 최대 92일 입니다.');
      return;
    }
    if (!dateCheck.isValue.isState) {
      toastr('top-right', 'warning', dateCheck.isValue.message);
      return;
    }
    this.divisionListSel();
    await this.setState({
      page: 1,
      excelPage: 1,
      excelData: [],
      detailList: null,
      statementId: null,
      isStatementRunning: false
    });
    this.detailedSikdaeList();
  };

  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      this.submitForm(e);
    }
  };

  pageClick = async (page) => {
    await this.setState({ page });

    const { statementId } = this.state;

    if (!statementId) {
      this.detailedSikdaeList();
      return;
    }

    try {
      this.setState({ loading: true });
      await this.fetchStatementResult(statementId, page);
    } catch (e) {
      const { response } = e;
      toastr(
        'top-right',
        'error',
        this.getStatementMessage(e) || (response && response.data && response.data.message) || '조회에 실패했습니다.'
      );
      console.log('###### detail statement pagination error : ', e);
    } finally {
      if (!this.isUnmounted) {
        this.setState({ loading: false });
      }
    }
  };

  cancelInfiniteScroll = async () => {
    const { statementId } = this.state;

    if (!statementId) {
      return;
    }

    try {
      await usageService.CancelSikdaeDtlStatement(statementId);

      if (!this.isUnmounted) {
        this.setState({
          isStatementCancelled: true,
          isStatementRunning: false,
          isFetchingMore: false
        });
      }
    } catch (e) {
      const message =
        this.getStatementMessage(e) ||
        this.getStatementMessage(e.response) ||
        (e.response && e.response.data && e.response.data.message) ||
        e.message ||
        'statement 취소 중 문제가 발생하였습니다.';

      toastr('top-right', 'error', message);
    }
  };

  openModal = (couponid) => {
    this.setState({ modal: true });

    const { usageAPI } = this.props;
    usageAPI.sikListDetail(couponid);
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  generateExcelFile = () => {
    const { commonsFn, date } = this.props;
    const { excelData } = this.state;
    const depth = storage.get('depth');

    const fileName = `식대_상세조회_${moment().valueOf()}.xlsx`;
    const searchDate = `${moment(date.sDate).format('YYYY-MM-DD')} ~ ${moment(date.eDate).format('YYYY-MM-DD')}`;
    const path = window.location.origin;
    const downloadDate = moment().format('YYYY-MM-DD HH:mm:ss');

    const newCols = [];
    for (let i = 1; i <= depth; i += 1) {
      newCols.push({ rowNum: 1, value: `부서${i}` });
    }
    const newRows = excelData.map((item) => {
      const division = cm.trTdDivision(item.orgCode);
      return [
        item.payroomidx,
        item.usedate,
        item.signid,
        item.username,
        item.comidnum,
        ...division,
        item.storename,
        item.compoint,
        item.tsalesprice,
        item.tcompanyprice,
        item.paytype
      ];
    });

    const apiExcelDatas = {
      0: {
        startRowNum: 1,
        customValues: [
          { address: 'C3', value: fileName },
          { address: 'C4', value: searchDate },
          { address: 'C5', value: path },
          { address: 'C6', value: downloadDate },
          { address: 'C7', value: '-' }
        ]
      },
      1: {
        startRowNum: 2,
        newRows,
        insertColNum: 6,
        newCols
      }
    };
    handleFileExport(detailSikdaeExcelJson, apiExcelDatas, fileName);
    commonsFn.reduxDataSet({
      type: 'download',
      name: 'isExcelDownload',
      value: false
    });
    this.setState({ excelPage: 1, excelData: [] });
  };

  handleExcelDownload = async () => {
    const { commonsFn, history } = this.props;

    this.setState({ isOpen: false });
    await commonsFn.reduxDataSet({
      type: 'download',
      name: 'isExcelDownload',
      value: true
    });

    try {
      await usageService.CreateSikdaeDtlExcel({
        ...this.getParams()
      });

      toastr('top-right', 'success', '엑셀 생성 요청이 완료되었습니다.');
      history.push('/main/excelDownloadList');
    } catch (e) {
      const message =
        this.getStatementMessage(e) ||
        this.getStatementMessage(e.response) ||
        (e.response && e.response.data && e.response.data.message) ||
        e.message ||
        '엑셀 생성 요청에 실패했습니다.';

      toastr('top-right', 'error', message);
    } finally {
      await commonsFn.reduxDataSet({
        type: 'download',
        name: 'isExcelDownload',
        value: false
      });
    }
  };

  handleExcelModalOpen = async () => {
    const { date } = this.props;
    const diff = moment(date.eDate).diff(date.sDate, 'day');
    if (diff > 92) {
      alert('엑셀 다운로드 기간은 최대 92일 입니다.');
    } else {
      this.setState({ isOpen: true });
    }
  };

  handleModalClose = () => {
    this.setState({ isOpen: false });
  };

  handleStopAPI = async () => {
    const { commonsFn } = this.props;
    const { onCancel } = this.state;
    await onCancel();
    this.setState({ excelPage: 1, excelData: [] });
    commonsFn.reduxDataSet({
      type: 'download',
      name: 'isExcelDownload',
      value: false
    });
  };

  handleStopAndDownload = () => {
    const { onCancel } = this.state;
    onCancel();
    this.generateExcelFile();
  };

  render() {
    const {
      sgl_use: sglUse,
      mul_use: mulUse,
      sgl_cancel: sglCancel,
      mul_cancel: mulCancel,
      user,
      store,
      startTime,
      endTime,
      clickEvent,
      modal,
      isOpen,
      loading,
      excelData,
      detailList,
      detailRows,
      partitionCount,
      currentPartition,
      totalRow,
      isFetchingMore,
      isStatementRunning,
      isStatementCancelled
    } = this.state;
    const formFn = {
      submitForm: this.submitForm,
      handleEntSubmit: this.handleEntSubmit
    };
    const selectFn = {
      user,
      store,
      startTime,
      endTime,
      sgl_use: sglUse,
      mul_use: mulUse,
      sgl_cancel: sglCancel,
      mul_cancel: mulCancel,
      clickEvent,
      initialize: this.initialize,
      addChoiceEvent: this.addChoiceEvent,
      delChoiceEvent: this.delChoiceEvent,
      groupSel: this.groupSel,
      policySel: this.policySel,
      timeChange: this.timeChange,
      paymentOption: this.paymentOption
    };
    const resultFn = {
      pageClick: this.pageClick,
      openModal: this.openModal,
      loadMorePartitions: this.loadMorePartitions,
      cancelInfiniteScroll: this.cancelInfiniteScroll
    };
    const modalFn = {
      modal,
      closeModal: this.closeModal
    };
    const { download } = this.props;
    const isLoading = download ? download.isExcelDownload : false;
    return (
      <main className="ds">
        {loading || isLoading ? (
          <LoadingBar key={excelData.length}>
            {isLoading ? (
              <div>
                <div style={{ fontSize: '20px', paddingTop: '10px' }}>
                  데이터를 수집하고 있습니다. 현재 조회 된 내역 {excelData.length.toLocaleString()}건
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', paddingTop: '50px' }}>
                  <Button onClick={this.handleStopAndDownload}>현재까지 조회 된 만큼 출력후 종료</Button>
                  <Button onClick={this.handleStopAPI}>강제종료</Button>
                </div>
              </div>
            ) : null}
          </LoadingBar>
        ) : null}
        <DetailedSikdaeForm formFn={formFn} />
        <DetailSikdaeSelectForm selectFn={selectFn} />
        <DetailSikdaeResultV2
          detailList={detailList}
          detailRows={detailRows}
          totalRow={totalRow}
          hasMore={!isStatementCancelled && partitionCount > 0 && currentPartition < partitionCount}
          isFetchingMore={isFetchingMore}
          isStatementRunning={isStatementRunning}
          resultFn={resultFn}
          modalFn={modalFn}
        />
        <Modal
          content={`식대 상세조회 엑셀을 다운로드 하시겠습니까?\n거래 기록에 따라 최대 수십분까지 소요 될 수 있습니다.`}
          actions={[
            { key: 'close', content: '취소', positive: false, onClick: this.handleModalClose },
            { key: 'done', content: '확인', positive: true, onClick: this.handleExcelDownload }
          ]}
          open={isOpen}
          style={{ width: 500, whiteSpace: 'break-spaces' }}
        />
      </main>
    );
  }
}

export default connect(
  (state) => ({
    // commons
    date: state.commons.date,
    dateCheck: state.commons.dateCheck,
    division: state.commons.division,
    sikGroup: state.commons.sikdaeGroup,
    sikPolicy: state.commons.sikdaePolicyArray,
    policyIdxs: state.commons.policyIdxArray,
    depth: state.commons.depth,
    text: state.commons.text,
    hour: state.commons.hour,
    staffList: state.commons.staff,
    storeList: state.commons.companyStore,
    divisionList: state.commons.pastDivision,
    excelResult: state.commons.excel,
    download: state.commons.download,

    // detail
    detailList: state.usage.detailList,
    listDetail: state.usage.listDetail,
    detailExcelList: state.usage.detailExcelList
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        sikGroupList: cmAction.SikdaeGroupList,
        sikPolicyList: cmAction.SikdaePolicyArray,
        staffSel: cmAction.StaffSel,
        storeSel: cmAction.StoreList,
        changeExcel: cmAction.ChangeExcel,
        changeTime: cmAction.ReduxDataSet,
        divisionSel: cmAction.PastDivisionList
      },
      dispatch
    ),
    commonsFn: bindActionCreators(
      {
        reduxDataSet: common.ReduxDataSet
      },
      dispatch
    ),
    usageAPI: bindActionCreators(
      {
        sikListDetail: usgAction.SikdaeListDtl,
        excelDownload: usgAction.ExcelSikdaeDtlList,
        sikdaeDtlExcelList: usgAction.SikdaeDtlExcelList
      },
      dispatch
    )
  })
)(DetailedSikdae);
